module.exports = __webpack_public_path__ + "resource/img/video.74b6a220.svg";